import React, { useState } from 'react';

import { ActionIcon } from '@mantine/core';
import { IconDotsVertical } from '@tabler/icons-react';

import { PatientData } from '@/types/patientList';

import { PatientOptionsMenuV2 } from '../PatientOptionsMenu/PatientOptionsMenuV2';

import styles from './cellsV2.module.scss';

interface OptionsCellProps {
  patient: PatientData;
}

export const OptionsCell: React.FC<OptionsCellProps> = ({ patient }) => {
  const [menuOpened, setMenuOpened] = useState(false);

  return (
    <PatientOptionsMenuV2 patient={patient} opened={menuOpened} onOpenChange={setMenuOpened}>
      <ActionIcon variant="subtle" color="gray" className={styles.optionsCell}>
        <IconDotsVertical size={18} stroke={1.8} />
      </ActionIcon>
    </PatientOptionsMenuV2>
  );
};
